module.exports = __webpack_public_path__ + "images/slide-2.jpg";